// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3a677aac","703":"ca0ada75","835":"af7d136f","888":"ebde0fd9","939":"b0158ce9","972":"004fc396"}[chunkId] + ".chunk.js";
};